import { AgeGroups } from "~enums/ageGroups";
import { CompetitorTypes } from "~enums/competitorTypes";
import { Disciplines } from "~enums/disciplines";
import { FixtureStatuses } from "~enums/fixtureStatuses.ts";
import { FixtureTypes } from "~enums/fixtureTypes";
import { Roles } from "~enums/roles";
import { SeasonTypes } from "~enums/seasonTypes";
import { Standards } from "~enums/standards.ts";
import type { SportConfiguration } from "~types/sportConfiguration";
import { defaultUiConfig } from "./defaultsUi";

const fixtureStatuses: FixtureStatuses[] = [
  FixtureStatuses.Scheduled,
  FixtureStatuses.Abandoned,
  FixtureStatuses.Bye,
  FixtureStatuses.Cancelled,
  FixtureStatuses.Confirmed,
  FixtureStatuses.Draft,
  FixtureStatuses.Finished,
  FixtureStatuses.IfNeeded,
  FixtureStatuses.InProgress,
  FixtureStatuses.Pending,
  FixtureStatuses.Postponed,
];

const seasonStandards: Standards[] = [
  Standards.Elite,
  Standards.Friendly,
  Standards.GrassRoot,
  Standards.International,
  Standards.Olympic,
  Standards.Region,
  Standards.Tier2,
  Standards.Tier3,
  Standards.WorldChampionship,
  Standards.ZoneChampionship,
];

const entityStandards: Standards[] = [
  Standards.Elite,
  Standards.Friendly,
  Standards.GrassRoot,
  Standards.International,
  Standards.Olympic,
  Standards.Region,
  Standards.Tier2,
  Standards.Tier3,
  Standards.WorldChampionship,
  Standards.ZoneChampionship,
];

const seasonOfficialRoles: Array<Roles> = [
  Roles.CrewChief,
  Roles.Groundskeeper,
  Roles.Referee,
  Roles.RefereeAssistant,
  Roles.RefereeAssistantReserve,
  Roles.RefereeReserve,
  Roles.Scorer,
  Roles.ScorerAssistant,
  Roles.ShotClockOperator,
  Roles.Statistician,
  Roles.Timer,
  Roles.Umpire,
  Roles.Umpire1,
  Roles.Umpire2,
];

const fixtureOfficialRoles: Array<Roles> = [...seasonOfficialRoles];

const staffRoles: Array<Roles> = [
  Roles.Coach,
  Roles.CoachAssistant,
  Roles.CoachHead,
  Roles.Director,
  Roles.MediaOfficer,
  Roles.Secretary,
  Roles.Timer,
  Roles.Trainer,
  Roles.Referee,
];

const seasonTypes = [SeasonTypes.Season, SeasonTypes.Tournament, SeasonTypes.OneOff, SeasonTypes.PreSeason];

const rosterPositions = [];

export const defaultsConfig: SportConfiguration = {
  competitorType: CompetitorTypes.Entity,
  fixtureStatuses,
  fixtureTypes: Object.values(FixtureTypes),
  ageGroups: Object.values(AgeGroups),
  disciplines: [Disciplines.Indoor, Disciplines.Outdoor],
  seasonStandards,
  entityStandards,
  uniforms: {
    bottomOptions: [],
    items: [],
  },
  seasonOfficialRoles,
  fixtureOfficialRoles,
  fixtureStaffRoles: staffRoles,
  seasonStaffRoles: staffRoles,
  seasonTypes,
  rosterPositions,
  uiConfiguration: defaultUiConfig,
  periods: {},
};
